import { fmtCena } from './receptUtils';

// Kalkulace jednoho kroku — donut + rozklad nákladů (4 kategorie).
export default function StepKalkulaceTab({ krokCost, jednotkaZkratka, receptTotal, isDark }) {
    const mutedColor = isDark ? 'rgba(255,255,255,0.4)' : 'var(--text-muted)';
    const secondaryColor = isDark ? 'rgba(255,255,255,0.55)' : 'var(--text-secondary)';

    if (!krokCost) {
        return (
            <div className="rounded-xl p-10 text-center" style={{ background: isDark ? 'rgba(255,255,255,0.03)' : 'var(--surface-base)', border: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : 'var(--border-default)'}` }}>
                <p className="text-sm" style={{ color: mutedColor }}>Náklady kroku se dopočítají z ingrediencí, času a stroje.</p>
            </div>
        );
    }

    const segs = [
        { l: 'Materiál', v: Number(krokCost.material) || 0, c: '#06B6D4' },
        { l: 'Odpad', v: Number(krokCost.scrap) || 0, c: '#EF4444' },
        { l: 'Stroje', v: Number(krokCost.machine) || 0, c: '#F97316' },
        { l: 'Práce', v: Number(krokCost.labor) || 0, c: '#8B5CF6' },
    ];
    const total = Number(krokCost.total) || 0;

    // Donut
    const size = 200, sw = 26, R = (size - sw) / 2, C = 2 * Math.PI * R, cx = size / 2;
    let acc = 0;
    const arcs = segs.filter(s => s.v > 0).map(s => {
        const len = (s.v / Math.max(total, 0.0001)) * C;
        const a = { ...s, len, offset: acc };
        acc += len;
        return a;
    });
    const track = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
    const tileBg = isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.02)';
    const tileBorder = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)';

    return (
        <div className="flex flex-wrap items-center gap-6">
            {/* Info karty — druhý sloupec (vlevo) */}
            <div className="flex-1 min-w-[220px] space-y-2">
                {segs.map(s => (
                    <div key={s.l} className="rounded-lg px-3 py-2.5 flex items-center gap-3" style={{ background: tileBg, border: `1px solid ${tileBorder}` }}>
                        <span style={{ width: 10, height: 10, borderRadius: 2, background: s.c, flexShrink: 0 }} />
                        <span className="flex-1 text-sm" style={{ color: secondaryColor }}>{s.l}</span>
                        <span className="text-[11px] font-medium" style={{ color: s.c, width: 34, textAlign: 'right' }}>{total > 0 ? Math.round((s.v / total) * 100) : 0}%</span>
                        <span className="text-sm font-bold" style={{ color: 'var(--text-primary)', minWidth: 78, textAlign: 'right' }}>{fmtCena(s.v)}</span>
                    </div>
                ))}
            </div>

            {/* Donut — doprava */}
            <div className="relative" style={{ width: size, height: size, flexShrink: 0, margin: '0 auto' }}>
                <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
                    <circle cx={cx} cy={cx} r={R} fill="none" stroke={track} strokeWidth={sw} />
                    {arcs.map(a => (
                        <circle key={a.l} cx={cx} cy={cx} r={R} fill="none" stroke={a.c} strokeWidth={sw}
                            strokeDasharray={`${a.len} ${C - a.len}`} strokeDashoffset={-a.offset}
                            style={{ transition: 'stroke-dasharray 0.4s, stroke-dashoffset 0.4s' }} />
                    ))}
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                    <div className="text-2xl font-bold leading-none" style={{ color: 'var(--text-primary)' }}>{fmtCena(total)}</div>
                    <div className="text-[11px] mt-1" style={{ color: mutedColor }}>náklad kroku{jednotkaZkratka ? ` / ${jednotkaZkratka}` : ''}</div>
                    {receptTotal > 0 && (
                        <div className="mt-1.5 text-[10px] font-semibold px-2 py-0.5 rounded-full" style={{ background: 'rgba(239,159,39,0.12)', color: '#EF9F27' }}>
                            {Math.round((total / receptTotal) * 100)} % z receptu
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
